import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Competition } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for competition detail query
const CACHE_TIME = 30 * 60 * 1000;

export const useCompetitionQuery = (id: string | undefined) => {
  return useQuery({
    queryKey: ['competition', { id: id! }],
    queryFn: fetchCompetition,
    enabled: !!id,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchCompetition: QueryFunction<Competition, [string, { id: string }]> = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const { data } = await axios.get<Competition>(`${API.endpoints.competitions}/${id}`);
  return data;
};
